<template>
  <div style="padding-top: 20px;">
    <div style="position: absolute;right: 10px;top: 10px;">
      <el-button type="primary" icon="el-icon-printer" @click="onPrint">打 印</el-button>
    </div>
    <div id="previewArea" class="preview-area">
      <div class="page" v-for="(dts, p) in data">
        <div class="table" v-for="i in dts">
          <div class="title">生产任务</div>
          <div class="content">
            <div class="row">
              <div class="row-item">
                <div class="label">订单号：</div>
                <div class="value">{{ i.OrderNo }}</div>
              </div>
              <div class="row-item">
                <div class="label">工单号：</div>
                <div class="value">{{ i.WorkDocNo }}</div>
              </div>
            </div>
            <div class="row">
              <div class="row-item">
                <div class="label">生产批号：</div>
                <div class="value">{{ i.BatchNumber }}</div>
              </div>
              <div class="row-item">
                <div class="label">产品名称：</div>
                <div class="value">{{ i.ProductName }}</div>
              </div>
            </div>
            <div class="row">
              <div class="row-item">
                <div class="label">产品条码：</div>
                <div class="value">{{ i.ProductNo }}</div>
              </div>
              <div class="row-item">
                <div class="label">规格型号：</div>
                <div class="value">{{ i.ProductSpec }}</div>
              </div>
            </div>
            <div class="row">
              <div class="row-item">
                <div class="label">生产班组：</div>
                <div class="value">{{ i.Team }}</div>
              </div>
              <div class="row-item">
                <div class="label">生产班次：</div>
                <div class="value">{{ i.Schedule }}</div>
              </div>
            </div>
            <div class="row">
              <div class="row-item">
                <div class="label">生产设备：</div>
                <div class="value">{{ i.EquipmentName }}</div>
              </div>
              <div class="row-item">
                <div class="label">任务数量：</div>
                <div class="value">{{ i.ThisPlanQuantity }}</div>
              </div>
            </div>
            <div class="row">
              <div class="row-item">
                <div class="label">计划开始时间：</div>
                <div class="value">{{ i.StartTime }}</div>
              </div>
              <div class="row-item">
                <div class="label">计划完成时间：</div>
                <div class="value">{{ i.EndTime }}</div>
              </div>
            </div>
          </div>
        </div>
        <span class="page-bottom">{{ p + 1 }} / {{ data.length }}</span>
      </div>
    </div>
    <div style="height: 20px;"></div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      data: [],
    }
  },
  created() { },
  mounted() {
    var printDataJson = sessionStorage.getItem('teamscheduling_print');
    this.setData(JSON.parse(printDataJson));
  },
  methods: {
    setData(row) {
      console.log("打 印", row);
      var list = row.PlanDts.map(x => {
        return {
          OrderNo: row.OrderNo, // 订单号
          WorkDocNo: row.WorkDocNo, // 工单号
          BatchNumber: row.BatchNumber, // 批次号
          ProductNo: row.ProductNo, // 产品编码 
          ProductName: row.ProductName, // 产品名称
          ProductSpec: row.ProductSpec, // 产品规格
          Team: x.Team, // 班组
          Schedule: x.Schedule, // 班次
          EquipmentNo: x.EquipmentNo, // 设备编码
          EquipmentName: x.EquipmentName, // 设备名称
          ThisPlanQuantity: x.ThisPlanQuantity, // 数量
          StartTime: x.StartTime, // 开始时间
          EndTime: x.EndTime, // 结束时间
        }
      })

      this.data = this.chunkArray(list, 3);
    },
    chunkArray(arr, chunkSize) {
      const chunks = [];
      for (let i = 0; i < arr.length; i += chunkSize) {
        chunks.push(arr.slice(i, i + chunkSize));
      }
      return chunks;
    },
    onPrint() {
      window.print();
    }
  }
}
</script>
<style lang="scss">
@media print {
  body * {
    visibility: hidden;
  }

  .preview-area,
  .preview-area * {
    visibility: visible;
  }

  .preview-area {
    position: absolute;
    left: 0;
    top: 0;
    border: none;
    box-shadow: none;

    .page {
      border: none !important;
      border: none;
      page-break-after: always;
    }
  }
}
</style>
<style lang="scss" scoped>
.preview-area {
  .page {
    width: 21cm;
    height: 29.7cm;
    background: white;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 20px;
    border: 1px dashed #ddd;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    .table {
      width: 94%;
      height: 320px;
      margin-top: 5%;

      .title {
        width: 100%;
        height: 48px;
        line-height: 48px;
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        border: 1px solid;
        border-bottom: none;
      }

      .content {
        width: 100%;
        border: 1px solid;

        .row {
          width: 100%;
          height: 45px;
          line-height: 45px;

          .row-item {
            float: left;
            width: 50%;
            display: flex;
            padding: 0 7px;

            .label {
              font-size: 14px;
              width: 105px;
            }

            .value {
              width: calc(100% - 105px);
            }
          }

          .row-item+.row-item {
            border-left: 1px solid;
          }
        }

        .row+.row {
          border-top: 1px solid;
        }
      }
    }

    .page-bottom {
      position: absolute;
      bottom: 13px;
    }
  }

  .page-break {
    page-break-after: always;
  }
}
</style>
